/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Features } from '../models/Features';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeaturesService {
    /**
     * returns all feature flags
     * @param tenantId tenant_id
     * @returns Features successful
     * @throws ApiError
     */
    public static getFeatures(
        tenantId: string,
    ): CancelablePromise<Features> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/features',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
